export default __webpack_public_path__ + "static/media/video-sdg-14.c2ab051f.mp4";